import React, {  useEffect, useState } from 'react';
import { get } from 'lodash';
import {  Loader, Icon, FileUploader } from 'components';
import { useSelect, useAction } from 'hooks';
import { useRouteMatch, Route } from 'react-router-dom';
import { Status } from '../transaction-history/ContainerTransactionItem';

const ReviewUploadedDocuments = ({ payment_id }) => {


  const [selectedRequirement, setSelectedRequirement] = useState(null)
  const { params } = useRouteMatch()
  const paymentId = payment_id || params.id
  
  const requirementList = useSelect('application.selectedRequirementsByPaymentId', { payment_id: paymentId });
  
  const showing = useSelect('loading.isLoading', { type: 'payment.view' })

  const reuploadRequirement = useAction('payment.reuploadRequirement')
  const reuploadingRequirements = useSelect('loading.isLoading', { type: 'payment.reuploadRequirement' })

  useEffect(() => {
    //  || (selectedRequirement && +get(selectedRequirement, 'id') !== +paymentId)
    if(!selectedRequirement){
      setSelectedRequirement(get(Object.values(requirementList), '0'))
    }
  }, [requirementList, selectedRequirement])

  const handleSelect = requirement => e => {
    e.preventDefault()
    setSelectedRequirement(requirement)
  }

  
  const hasUrl = selectedRequirement && get(selectedRequirement, 'attributes.requirement_url') !== ''

  const handleUpload = file => {
    reuploadRequirement(paymentId, get(selectedRequirement, 'id'), { url: file.cdnUrl }, (responseData) => {
      
      setSelectedRequirement(Object.values(responseData)[0])
    })
  }
  
  return (
    <>
      <div className="flex flex-col xl:flex-row">
        <div className="w-full xl:w-4/12">
          {showing && <Loader.Table />}
          {!showing && <ul className="flex flex-col">
            {Object.values(requirementList).map(item => {
              
              return (
                <li key={`requirements${get(item, 'id')}`} className={`h-16 ${+get(selectedRequirement, 'id') === +get(item, 'id')  ? 'bg-gray-300' : ''} flex items-center px-2`}>
                  <a href="jsx-a11y/anchor-is-valid" className="text-sm" onClick={handleSelect(item)}>
                    {/* {(get(item, 'attributes.is_required') && get(item, 'attributes.requirement_url') === '' ||
                     (get(item, 'attributes.is_required') && get(item, 'attributes.status') === 'FOR RESUBMISSION')) 
                      ? <span className="rounded px-1 bg-info text-white text-sm mr-2">Required</span>
                      : <Icon.BoxCheck className="inline-flex mr-2"/>
                    } */}
                    {get(item, 'attributes.name')}
                  </a>
                </li>
              )
            })}
          </ul>}
        </div>
        <div className="flex-1 flex flex-col border-4 border-gray-300 p-2">
          <div className="pb-2 border-b-2 border-gray-300 flex flex-col xl:flex-row lg:flex-row">
            <div className="flex-1 flex space-x-0 xl:space-x-2 items-center">
            <Route path="/application/:id/resubmit" render={() => {
              return (
                <FileUploader isLoading={reuploadingRequirements}  onChange={handleUpload} className="btn btn-primary w-full xl:w-auto lg:w-auto"><Icon.Upload /><span>Upload Attachment</span></FileUploader>
              )
            }}/>
            </div>
            <div className="flex flex-col xl:flex-row lg:flex-row space-x-0 xl:space-x-2 lg:space-x-2 items-center">
              <span className="text-sm">Status: </span>
              <Status type="sm" value={get(selectedRequirement, 'attributes.status')}/>
              <span className="text-sm">Remarks: <span className="font-medium">{get(selectedRequirement, 'attributes.remarks')}</span></span>
            </div>
          </div>
          <div className={`flex p-2 overflow-auto ${hasUrl ? 'bg-gray-800' : ''}`} style={{ maxHeight: 800, height: 800 }}>
            {!hasUrl &&
            <span className="m-auto font-bold text-md text-gray-600">No current attachment</span> }
            {hasUrl && <img className="m-auto" src={get(selectedRequirement, 'attributes.requirement_url')} alt="attachment"/>}
          </div>
        </div>
      </div>
      
    </>
  )
}

export default ReviewUploadedDocuments